export default "__VITE_ASSET__D5j$pk6J__"